import request from "@/util/http";
import qs from "qs"; // 权责列表查询

export var getDutyList = function getDutyList(params) {
  return request({
    url: "/admin/charge/page",
    method: "get",
    params: params
  });
}; // 权责单个删除

export var handleDutyDelete = function handleDutyDelete(id) {
  return request({
    url: "/admin/charge/delete/".concat(id),
    method: "delete"
  });
}; // 权责信息

export var getDutyInfo = function getDutyInfo(id) {
  return request({
    url: "/admin/charge/get/".concat(id),
    method: "get"
  });
}; // 保存权责

export var hallSaveOrUpdate = function hallSaveOrUpdate(data) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/charge/saveOrUpdate",
    method: "post",
    data: JSON.stringify(data)
  });
};